import React, { useEffect, useState } from "react";
import { X, Plus, Check, Soup, Cake } from "lucide-react";
import { useCart } from "../context/CartContext";
import client from "../lib/api";
import { toast } from "sonner";

const ExtrasModal = () => {
  const { pending, confirmAdd, closeModal } = useCart();
  const [extras, setExtras] = useState(null);
  const [selected, setSelected] = useState({});

  useEffect(() => {
    if (pending && !extras) {
      client.get("/menu").then((res) => setExtras({ ...res.data.extras, byDay: res.data.sweets_of_day })).catch(() => {});
    }
    if (!pending) setSelected({});
  }, [pending, extras]);

  if (!pending) return null;

  const toggle = (item) =>
    setSelected((s) => ({ ...s, [item.id]: s[item.id] ? undefined : item }));

  const handleAdd = () => {
    const chosen = Object.values(selected).filter(Boolean);
    confirmAdd(chosen);
    toast.success("Added to cart", { description: pending.name });
  };

  const rows = extras
    ? [
        { key: "soup", heading: "Serbian Soup", Icon: Soup, item: extras.soup },
        ...(extras.byDay?.[pending.day]
          ? [{ key: "sweet", heading: `Sweet of the Day (${pending.day})`, Icon: Cake, item: extras.byDay[pending.day] }]
          : []),
      ]
    : [];

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={closeModal} />
      <div className="relative w-full sm:max-w-md bg-[#fdf8f1] rounded-t-3xl sm:rounded-3xl shadow-2xl p-6 max-h-[88vh] overflow-y-auto">
        <button onClick={closeModal} className="absolute top-4 right-4 text-[#8a7458] hover:text-[#2c1e12]" aria-label="Close">
          <X className="h-6 w-6" />
        </button>
        <h3 className="font-heading text-2xl font-bold text-[#2c1e12] pr-8">Would you like to add something extra?</h3>
        <p className="text-sm text-[#8a7458] mt-1">Adding: {pending.name}</p>

        <div className="mt-5 space-y-5">
          {rows.map(({ key, heading, Icon, item }) => (
            <div key={key}>
              <div className="flex items-center gap-2 text-[#9a4a2f] font-semibold mb-2">
                <Icon className="h-5 w-5" /> {heading}
              </div>
              <div className="flex items-center gap-3 rounded-2xl bg-[#f6ece0] p-3">
                <img src={item.image} alt={item.name} className="h-14 w-14 rounded-xl object-cover" />
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-[#2c1e12] leading-tight">{item.name}</p>
                  <p className="text-xs text-[#8a7458] line-clamp-1">{item.desc}</p>
                  <p className="text-sm font-bold text-[#9a4a2f] mt-0.5">${item.price.toFixed(2)}</p>
                </div>
                <button
                  onClick={() => toggle(item)}
                  className={`h-9 w-9 rounded-full flex items-center justify-center transition-colors ${
                    selected[item.id] ? "bg-[#2c6e49] text-white" : "bg-[#9a4a2f] text-white hover:bg-[#853e26]"
                  }`}
                  aria-label={`Add ${item.name}`}
                >
                  {selected[item.id] ? <Check className="h-5 w-5" /> : <Plus className="h-5 w-5" />}
                </button>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleAdd}
          className="mt-6 w-full rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold py-3.5 transition-colors"
        >
          Add to Cart
        </button>
        <button onClick={handleAdd} className="mt-2 w-full text-center text-sm text-[#8a7458] hover:text-[#2c1e12] py-1">
          No thanks — just the meal
        </button>
      </div>
    </div>
  );
};

export default ExtrasModal;
